import { DEX_TYPE } from '@/config/constants'
import SgTraDexLogo from '@/assets/svgs/SGTraDex-logo-new.svg?react'
import SGTradexLandingPageLogo from '@/assets/svgs/logo-sgtradex.svg?react'
import BuilDexLogo from '@/assets/svgs/buildex-nav-logo.svg?react'
import BuildexLandingPageLogo from '@/assets/svgs/buildex-landing-logo.svg?react'
import BuilDexCircularHero from '@/assets/svgs/hero-circular-shape-buildex.svg?react'
import HealthDexLogo from '@/assets/svgs/healthdex-nav-logo.svg?react'
import HealthDexLandingPageLogo from '@/assets/svgs/healthdex-landing-logo.svg?react'
import HealthDexCircularHero from '@/assets/svgs/hero-circular-shape-healthdex.svg?react'
import SgTraDexCircularHero from '@/assets/svgs/hero-circular-shape-tradex.svg?react'

import BuilDexLogoSrc from '@/assets/svgs/buildex-nav-logo.svg?url'
import SGTradexLogoSrc from '@/assets/svgs/logo-sgtradex.svg?url'
import HealthDexLogoSrc from '@/assets/svgs/healthdex-nav-logo.svg?url'

export const DEX_CONFIG = {
  [DEX_TYPE.SGBUILDEX]: {
    dexName: 'SGBuildex',
    tagline: 'Making your building and construction data sharing easy and secure',
    backgroundImage: 'Buildex-full__BG.png',
    favicon: '/buildex-favicon.ico',
    LogoComponent: BuilDexLogo,
    LogoSrc: BuilDexLogoSrc,
    LandingLogo: BuildexLandingPageLogo,
    HeroCircle: BuilDexCircularHero,
  },
  [DEX_TYPE.SGTRADEX]: {
    dexName: 'SGTraDex',
    tagline: 'Making your trade data sharing easy and secure',
    backgroundImage: 'Sgtradex-full__BG.png',
    favicon: '/tradex-favicon.ico',
    LogoComponent: SGTradexLandingPageLogo,
    LogoSrc: SGTradexLogoSrc,
    LandingLogo: SgTraDexLogo,
    HeroCircle: SgTraDexCircularHero,
  },
  [DEX_TYPE.SGHEALTHDEX]: {
    dexName: 'SGHealthDex',
    tagline: 'Making your healthcare data sharing easy and secure',
    backgroundImage: 'Healthdex-full__BG.png',
    favicon: '/healthdex-favicon.ico',
    LogoComponent: HealthDexLogo,
    LogoSrc: HealthDexLogoSrc,
    LandingLogo: HealthDexLandingPageLogo,
    HeroCircle: HealthDexCircularHero,
  },
}

export function getDexConfig(dexType) {
  const defaultConfig = DEX_CONFIG[DEX_TYPE.SGBUILDEX]
  const currentConfig = DEX_CONFIG[dexType] || {}

  return {
    backgroundImage: currentConfig.backgroundImage ?? defaultConfig.backgroundImage,
    favicon: currentConfig.favicon ?? defaultConfig.favicon,
    LogoComponent: currentConfig.LogoComponent ?? defaultConfig.LogoComponent,
    LogoSrc: currentConfig.LogoSrc ?? defaultConfig.LogoSrc,
    LandingLogo: currentConfig.LandingLogo ?? defaultConfig.LandingLogo,
    dexName: currentConfig.dexName ?? defaultConfig.dexName,
    tagline: currentConfig.tagline ?? defaultConfig.tagline,
    HeroCircle: currentConfig.HeroCircle ?? null,
  }
}
